import React, { useState } from "react";
import EnquireModal from "./EnquireModal";

const EnquireButton = ({ showShippingNote = true, paintingTitle, price }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <div style={{ textAlign: "center", marginTop: "1.5rem", marginBottom: "2rem" }}>
        <button
          onClick={() => setModalOpen(true)}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={{
            display: "inline-block",
            padding: "14px 32px",
            backgroundColor: isHovered ? "#000" : "transparent",
            color: isHovered ? "#fff" : "#000",
            border: "1px solid #000",
            borderRadius: "0",
            fontSize: "0.85rem",
            letterSpacing: "0.12em",
            textTransform: "uppercase",
            transition: "background-color 0.2s ease, color 0.2s ease",
            cursor: "pointer",
            fontFamily: "inherit",
          }}
        >
          Enquire about this painting
        </button>
        {showShippingNote && (
          <p style={{ fontSize: "0.85rem", color: "darkgray", margin: "1rem 0 0 0" }}>
            Shipping available Australia-wide and internationally. Get in touch to discuss.
          </p>
        )}
      </div>

      <EnquireModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        paintingTitle={paintingTitle}
        price={price}
      />
    </>
  );
};

export default EnquireButton;
